module.exports = __webpack_public_path__ + "static/awscdk-e1e33767cc42334c05ce71ec524b5410.png";